import React, { useEffect, useState } from "react";

import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  Button,
  Spinner,
  InputGroup,
  Input,
  
  InputGroupText,
} from "reactstrap";
import { MdModeEdit, MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiClient from "../../api-client";
import Swal from 'sweetalert2';
import SubcategoryModal from "./SubcategoryModal";
import { useDispatch } from "react-redux";
import { getDescription } from "../../utils/common";

function SubcategoryList() {
  const dispatch = useDispatch();
  const [categoryData, setCategoryData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [counting, setCounting] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [alertLoader, setAlertLoader] = useState(false);
  const [showAlter, setShowAlter] = useState(false);
  const pageSize = 10;
  const [searchQuery, setSearchQuery] = useState("");
  const [loader, setLoader] = useState(false);
  const [subcategoryId, setsubCategoryId] = useState(null);

  const fetchAllSubcategory = async (pageNumber=currentPage, query = "") => {
    try {
      setLoader(true);
      const getAllSubcategory = await ApiClient.get(
        `api/category/get-all-subcategory?page=${pageNumber}&limit=${pageSize}&searchText=${query}`,
        "",
        true,
        dispatch
      );
      setCategoryData(getAllSubcategory.body.result);
      setCounting(getAllSubcategory.body);
      setLoader(false);
    } catch (error) {
      toast.error(error.message, { autoClose: 3000 });
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchAllSubcategory(currentPage, searchQuery);
  }, [currentPage, searchQuery]);

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const openAlertDialog = (id) => {
    setsubCategoryId(id);
    setShowAlter(true);
  };
  const handleDelete = async () => {
    if (subcategoryId) {
      try {
        setAlertLoader(true);
        const deleteUser = await ApiClient.delete(
          `api/category/delete-subcategory`,
          { id: subcategoryId },
          true,
          dispatch
        );
        setAlertLoader(false);
        setShowAlter(false);
        fetchAllSubcategory(currentPage, searchQuery);
        toast.success(deleteUser.message, { autoClose: 3000 });
      } catch (error) {
        setAlertLoader(false);
        toast.error(error.message, { autoClose: 3000 });
      }
    }
  };

  const toggleModal = (d) => {
    if (d.status) {
      fetchAllSubcategory();
    }
    setsubCategoryId(null)
    setModalOpen(!modalOpen);
  };

  const editSubcategory = (id) => {
    setsubCategoryId(id)
    setModalOpen(!modalOpen);
  }
  
  return (
    <>
      <div className="content">
        <Row>
          <SubcategoryModal fetchAllSubcategory={fetchAllSubcategory} isOpen={modalOpen} subcategoryId={subcategoryId} toggle={toggleModal} />
          <Col md="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="5 ">
                  </Col>
                  <Col md="4">
                    <form>
                      <InputGroup className="no-border">
                        <Input
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={handleSearch}
                        />
                          <InputGroupText>
                            <i className="nc-icon nc-zoom-split" />
                          </InputGroupText>
                      </InputGroup>
                    </form>
                  </Col>
                  <Col md="3">
                    <Button
                      color="primary"
                      className="common-button mt-0"
                      onClick={toggleModal}
                    >
                      Add Subcategory
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {loader && (
                  <span className="table-loader">
                    <Spinner color="primary">Loading...</Spinner>
                  </span>
                )}
                {!loader && (
                  <>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Category Name</th>
                          <th>Subcategory Name</th>
                          <th>Subcategory Description</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {categoryData?.map((data) => (
                          <tr key={data._id}>
                            <td>{data?.categoryName}</td>
                            <td>{data?.subCategoryName}</td>
                            <td>{getDescription(data?.subCategoryDescription)}</td>
                            <td className="text-center">
                              <span
                                className="action-icon action-icon-yellow"
                                onClick={() => editSubcategory(data._id)}
                              >
                                <MdModeEdit />
                              </span>
                              <span
                                className="action-icon action-icon-red"
                                onClick={() => openAlertDialog(data._id)}
                              >
                                <MdDelete />
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="pagination d-flex justify-content-center align-items-center">
                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                        className="common-button"
                      >
                        Previous
                      </Button>
                      <span className="mx-3">
                        Page {counting?.currentPage} of {counting?.totalPages}
                      </span>
                      <span className="mx-3">
                        <strong>Total records: </strong>
                        {counting?.totalRecords}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage === counting?.totalPages}
                        className="common-button"
                      >
                        Next
                      </Button>
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      {showAlter && (
        <Swal
          danger
          showCancel
          confirmBtnText={
            alertLoader ? (
              <span>
                Confirm <Spinner size="sm" />
              </span>
            ) : (
              "Confirm"
            )
          }
          confirmBtnBsStyle="danger"
          title="Are you sure?"
          onConfirm={handleDelete}
          onCancel={() => setShowAlter(false)}
          focusCancelBtn
        >
          You want to delete this subcategory
        </Swal>
      )}
    </>
  );
}

export default SubcategoryList;
